const globalTheme = {
  dark: {
    background: '#101010',
    border: '#0B0B0B',
    text: '#FFFFFF',
  },
  light: {
    background: '#FFFFFF',
    border: 'rgba(221,221,221, .6)',
    text: '#0B0B0B',
  },
}

export default globalTheme
